export default "__VITE_ASSET__CB_9YKkV__"